import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const HOME = 'home'
export const REPORT = 'report'
export const SURVEY_RESULTS = 'survey-results'
export const SETTINGS = 'settings'
export const ALL_SURVEYS = 'all-surveys'
export const NO_REPORTS = 'no-reports'
export const QUOTA = 'quota'
export const SAMPLE_LIVE_INFO = 'sample live info'
export const SAMPLE_PAUSED_INFO = 'sample paused info'
export const LIVE = 'live'
export const PAUSED = 'paused'
export const GENERATE = 'GENERATE'
export const COPY = 'COPY'
export const COPIED = 'COPIEDD'

export default {
  [PORTUGUESE]: {
    [HOME]: 'Pagina Inicial',
    [REPORT]: 'Relatório',
    [SURVEY_RESULTS]: 'Resultados da Pesquisa',
    [SETTINGS]: 'Configurações',
    [ALL_SURVEYS]: 'Todas as Pesquisas',
    [NO_REPORTS]: 'Ops! Esta pesquisa pode não ter um relatório',
    [QUOTA]: 'Cota',
    [SAMPLE_LIVE_INFO]: `Esta pesquisa está coletando respostas nesse momento.</br></br>
    Você não pode modificar o questionário e, caso decida fazê-lo, todas as respostas coletadas até o momento serão excluídas permanentemente.</br></br>
    Vá para a seção "Sample/Cotas" e selecione "Pausar amostra" para interromper a coleta de respostas`,
    [SAMPLE_PAUSED_INFO]: `Esta pesquisa não está coletando respostas no momento.</br></br>
    Caso você já tenha coletado respostas, esteja ciente de que qualquer modificação feita no questionário excluirá permanentemente todas as respostas coletadas até o momento.</br></br>
    Vá para a seleção "Sample/Quotas" e selecione "Começar Campo" para começar a coletar respostas.
    `,
    [LIVE]: 'Live',
    [PAUSED]: 'Pausado',
    [GENERATE]: 'Gerar',
    [COPY]: 'Copiar',
    [COPIED]: 'Copiado',
  },

  [ENGLISH]: {
    [HOME]: 'Home',
    [REPORT]: 'Report',
    [SURVEY_RESULTS]: 'Survey Results',
    [SETTINGS]: 'Settings',
    [ALL_SURVEYS]: 'All Surveys',
    [NO_REPORTS]: 'Ops! This survey might not have a report',
    [QUOTA]: 'Quota',
    [SAMPLE_LIVE_INFO]: `This survey is currently collecting responses.</br></br>
    You are not able to modify the questionnaire, and in case you decide to do so, all of the answers collected so far will be permanently deleted.</br></br>
    Go to "Sample/Quotas" section and select "Paused Sample" stop collecting
    responses.`,
    [SAMPLE_PAUSED_INFO]: `This survey is not collecting responses right now.</br></br>
    In case you have already collected responses, be aware thar any modifications made on the questionnaire will permanently delete all of the response collected so far.</br></br>
    Go to "Sample/Quotas" selection and select "Launch Sample" to start collecting responses.
    `,
    [LIVE]: 'Live',
    [PAUSED]: 'Paused',
    [GENERATE]: 'Create',
    [COPY]: 'Copy',
    [COPIED]: 'Copied!',
  },

  [SPANISH]: {
    [HOME]: 'Página de Inicio',
    [REPORT]: 'Reporte',
    [SURVEY_RESULTS]: 'Resultados de la Encuesta',
    [SETTINGS]: 'Ajustes',
    [ALL_SURVEYS]: 'Todas las Encuestas',
    [NO_REPORTS]: 'Ops! Es posible que esta encuesta no tenga un informe.',
    [QUOTA]: 'Cuota',
    [SAMPLE_LIVE_INFO]: `Esta encuesta está recolectando respuestas en este momento.</br></br>
    No es posible modificar el cuestionario y, en caso de que decida hacerlo, todas las respuestas recopiladas hasta el momento van a ser eliminadas de forma permanente.</br></br>
    Vaya a la sección "Sample/Cuotas" y seleccione "Pausar muestra" para dejar de recopilar respuestas.`,
    [SAMPLE_PAUSED_INFO]: `Esta encuesta no está recopilando respuestas en este momento.</br></br>
    En caso de que ya haya recopilado respuestas, tenga en cuenta que cualquier modificación realizada en el cuestionario eliminará de forma permanente todas las respuestas recopiladas hasta el momento.</br></br>
    Vaya a la sección "Sample/Cuotas" y seleccione "Empezar Campo" para comenzar a recopilar respuestas.`,
    [LIVE]: 'Live',
    [PAUSED]: 'En Pausa',
    [GENERATE]: 'Gerar',
    [COPY]: 'Copiar',
    [COPIED]: 'Copiado',
  },
}
